interface Props {
  activeColor: string;
  bgColor?: string;
}

const WarmLeadIcon = ({ activeColor, bgColor }: Props) => {
  const fillColor = activeColor === "#0f1560" ? "#EA580C" : "#0f1560";
  const bgFillColor = bgColor ? bgColor : "#e3e9fc";

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill={bgFillColor} />

      <path
        d="M14 24 
       H18 
       L21 18 
       L25 30 
       L28 22 
       H34"
        stroke="#2F4BFF"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WarmLeadIcon;
